import React from 'react';
import BaseComponent from "../BaseComponent.js";
import styled from 'styled-components';
import nota from '../Global/nota.guidelines.json';
import moment from 'moment';

import NanoFlex from '../Global/NanoFlex.js';
import InputWheel from './InputWheel.js';

const now = moment();
const currentYear = now.format(nota.global.moment.year);

const monthsList = moment.monthsShort();
const yearsList = new Array(300).fill(1900).map((v, i) => v + i);

const multiple = nota.global.multiple;

const StyledDateInputWheel = styled.div`
    position: relative;
    margin-right: ${multiple + 'px'}; /* 8px */;
    .wheelWrapper {
        height: ${multiple * 7 + 'px'}; /* 56px */;
        border: 1px solid ${nota.color.neutral.NeuTwo};
    }
`;

class DateInputWheel extends BaseComponent {
    constructor(props) {
        super(props);

        const yearInitialIndex = yearsList.indexOf(parseInt(currentYear));

        this.state = {
            date: {
                day: 0,
                month: this.props.secondDefaultMonth ? 1 : 0,
                year: yearInitialIndex
            },
            daysList: this.createDaysList(0, yearInitialIndex)
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.date.day !== this.state.date.day || prevState.date.month !== this.state.date.month || prevState.date.year !== this.state.date.year) {
            const { date, daysList } = this.state;
            const newDaysList = this.createDaysList(date.month, date.year);
            if (newDaysList !== daysList) this.setState({ daysList: this.createDaysList(date.month, date.year) });

            if (this.props.onDateChange) this.props.onDateChange(this.outputNewDate(date, daysList));
        };

        if (this.props.date && prevProps.date !== this.props.date) {
            this.updateDateFromProps(this.props.date);
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    outputNewDate = (dateObj, daysList) => {
        return `${daysList[dateObj.day]}-${this.addZero(dateObj.month + 1)}-${yearsList[dateObj.year]}`;
    }

    createDaysList = (monthIndex, yearIndex) => {
        const newDate = `01-${this.addZero(monthIndex + 1)}-${yearsList[yearIndex]}`;
        const daysInMonth = moment(newDate, this.getDateOutputFormat()).daysInMonth();

        return new Array(daysInMonth).fill(1).map((v, i) => v + i);
    }

    updateDateIndex = (type, index, list) => {
        const { date } = this.state;

        this.setState({
            date: {
                day: type === 'day' ? index : date.day,
                month: type === 'month' ? index : date.month,
                year: type === 'year' ? index : date.year
            }
        });
    }

    updateDateFromProps = (date) => {
        const newDay = moment(date, this.getDateOutputFormat()).format(nota.global.moment.day);
        const newMonth = moment(date, this.getDateOutputFormat()).format(nota.global.moment.month);
        const newYear = moment(date, this.getDateOutputFormat()).format(nota.global.moment.year);

        const monthIndex = parseInt(newMonth) - 1;
        const yearIndex = yearsList.indexOf(parseInt(newYear));

        const newDaysList = this.createDaysList(monthIndex, yearIndex);

        this.setState({
            date: {
                day: newDay - 1,
                month: monthIndex,
                year: yearIndex
            },
            daysList: newDaysList
        });
    }

    addZero = (input) => {
        if (!input) return '01';

        const inputNumber = parseInt(input);
        return inputNumber < 10 ? '0' + inputNumber : inputNumber.toString();
    }

    render() {
        return (
            <StyledDateInputWheel>
                <NanoFlex className="wheelWrapper">
                    <InputWheel
                        data={this.state.daysList}
                        type='day'
                        selected={this.state.date.day}
                        onDateChange={(type, index, list) => this.updateDateIndex(type, index, list)}
                    />
                    <InputWheel
                        data={monthsList}
                        type='month'
                        selected={this.state.date.month}
                        onDateChange={(type, index, list) => this.updateDateIndex(type, index, list)}
                    />
                    <InputWheel
                        data={yearsList}
                        type='year'
                        selected={this.state.date.year}
                        onDateChange={(type, index, list) => this.updateDateIndex(type, index, list)}
                    />
                </NanoFlex>
            </StyledDateInputWheel>
        );
    }
};

export default DateInputWheel;

// --- // Documentation // --- //
/*
import DateInputWheel from './../Nano/DateInputWheel.js';

<DateInputWheel
    onDateChange={(newDate) => console.log('DateInputWheel', newDate)}
/>
*/
